import HistoryIcon from "@mui/icons-material/History";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import PaymentsIcon from "@mui/icons-material/Payments";
import { Box, Chip, IconButton, Tooltip } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PaperCustomized from "../../../common/components/PaperCustomized";
import TableCustomized from "../../../common/components/TableCustomized";

import {
  TITRE_DETAIL_PAGE,
  TITRE_HISTORIQUE_PAGE,
} from "../../../common/constants/routerConstants";
import {
  formattedDateTimeFromDB,
  getChipColorByEtatCodeTi,
  hasAnyRole,
} from "../../../common/utils/FunctionsUtils";
import {
  clearTiDetails,
  downloadTi,
  setIsDecisionTiVisible,
  setTiColumnsDensityState,
} from "../state/TiActions";

function ListTitres(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tiReducer = useSelector((state) => state.tiReducer);
  const isDecisionMode = tiReducer?.isDecisionMode;
  const [isPronlogation, setIsProlongation] = useState(null);
  const [hoveredRowId, setHoveredRowId] = useState(null);
  const [actionComponentHeight, setActionComponentHeight] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [actionsPosition, setActionsPosition] = useState({
    y: 0,
    visible: false,
  });
  const gridRef = useRef(null);
  const [isOverActionsComponent, setIsOverActionsComponent] = useState(false);
  const [columnVisibility, setColumnVisibility] = useState(
    tiReducer?.columnsState
  );
  const [density, setDensity] = useState(tiReducer?.density);

  const findRowById = (rowId) => {
    let row = tiReducer?.titres?.content?.find((elm) => elm?.id == rowId);

    if (row?.typeEtatTitreImportation?.code === "ECHU_SOUM_PROL") {
      setIsProlongation(true);
    } else {
      setIsProlongation(false);
    }
    return row;
  };

  useEffect(() => {
    const handleScroll = (event) => {
      setActionsPosition((prevState) => ({
        ...prevState,
        visible: false,
      }));
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const isReponsesActionActive = (titreImportation) => {
    const isGestion = isDecisionMode;
    const isEtatDomicilieSoumisPourModificationBanque =
      titreImportation.typeEtatTitreImportation.code === "DOM_SOUMI_BAN";
    const isEtatRegle =
      titreImportation.typeEtatTitreImportation.code === "REGL";
    const isEtatRegleEnPartie =
      titreImportation.typeEtatTitreImportation.code === "REGLP";
    const isModificationEnvoyeALaBanque =
      titreImportation.etatModification === 2;
    const canSendReponseBancaire = titreImportation.allowSendRespuestaBanco;
    const isDomiciliationConfirme = titreImportation.domicilicacionConfirmed;
    const isDernierMessageReporte =
      titreImportation.msgTituloImpLast?.etat.code === "REP";

    return (
      (canSendReponseBancaire &&
        isGestion &&
        ((isDernierMessageReporte && isDomiciliationConfirme) ||
          !isDernierMessageReporte)) ||
      isEtatDomicilieSoumisPourModificationBanque ||
      ((isEtatRegle || isEtatRegleEnPartie) && isModificationEnvoyeALaBanque)
    );
  };

  const isConnectedBanque = (titreImportation) => {
    const isConnectedBanque =
      !!titreImportation?.currentBank || !!titreImportation?.isCurrentBank;
    return isConnectedBanque;
  };

  const isReglementActionActive = (titreImportation) => {
    const isGestion = isDecisionMode;
    const isEtatDomicilie =
      titreImportation.typeEtatTitreImportation.code === "DOM";
    const isEtatEchu =
      titreImportation.typeEtatTitreImportation.code === "ECHU";
    const isEtatRegle =
      titreImportation.typeEtatTitreImportation.code === "REGL";
    const isEtatRegleEnPartie =
      titreImportation.typeEtatTitreImportation.code === "REGLP";
    const isEtatApure =
      titreImportation.typeEtatTitreImportation.code === "APUR";
    const isDonneesReglementParEtatActive =
      titreImportation.donneesReglementParEtatActive;
    const isAttRepChangeGuichBanqActuel =
      titreImportation?.msgTituloImpLast?.typeMessage?.code === "DCG";

    return (
      isGestion &&
      (isEtatDomicilie ||
        isEtatEchu ||
        isEtatRegle ||
        isEtatRegleEnPartie ||
        isEtatApure ||
        isAttRepChangeGuichBanqActuel) &&
      isDonneesReglementParEtatActive
    );
  };

  const ActionsComponent = ({
    row,
    yPosition = 0,
    isVisible = false,
    height,
    width,
  }) => {
    const thresholdX =
      width +
      (isDecisionMode ? 0 : 32) -
      (isDecisionMode ? 68 : 60) +
      (tiReducer.drawer?.open ? tiReducer.drawer?.width : 0);

    const handleMouseLeave = (e) => {
      const currentX = e.clientX;
      if (currentX > thresholdX) {
        setHoveredRowId(null);
        setActionsPosition((prevState) => ({ ...prevState, visible: false }));
      }
      setIsOverActionsComponent(false);
    };

    if (!isVisible) {
      setHoveredRowId(null);
      return null;
    }

    setHoveredRowId(row?.id);

    const style = {
      position: "fixed",
      top: `${yPosition}px`,
      height: `${height}px`,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      background: "#e8e8e8",
      paddingRight: "15px",
      transition: "background-color 0.3s, box-shadow 0.3s",
      left:
        width +
        32 -
        60 +
        (tiReducer.drawer?.open ? tiReducer.drawer?.width : 0),
      width: 60,
    };

    return isVisible ? (
      <div
        style={style}
        onMouseEnter={() => setIsOverActionsComponent(true)}
        onMouseLeave={handleMouseLeave}
      >
        {row &&
          !hasAnyRole(["ROLE_VUPORTUARIA_ADMIN"]) &&
          isReponsesActionActive(row) && (
            <Tooltip
              title="Réponses"
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -12],
                      },
                    },
                  ],
                },
              }}
            >
              <Box
                sx={{
                  height: actionsPosition?.height,
                  alignContent: "center",
                  backgroundColor: "#e8e8e8",
                }}
              >
                <IconButton
                  aria-haspopup="true"
                  onClick={() => {
                    handleRowClick(row, true, false, true);
                  }}
                  sx={{ color: "primary.main" }}
                >
                  <KeyboardReturnIcon />
                </IconButton>
              </Box>
            </Tooltip>
          )}
        {row &&
          !hasAnyRole(["ROLE_VUPORTUARIA_ADMIN"]) &&
          isReglementActionActive(row) &&
          isConnectedBanque(row) && (
            <Tooltip
              title="Données du règlement"
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, -12],
                      },
                    },
                  ],
                },
              }}
            >
              <Box
                sx={{
                  height: actionsPosition?.height,
                  alignContent: "center",
                  backgroundColor: "#e8e8e8",
                }}
              >
                <IconButton
                  aria-haspopup="true"
                  onClick={() => {
                    handleRowClick(row, true, true, false);
                  }}
                  sx={{ color: "primary.main" }}
                >
                  <PaymentsIcon />
                </IconButton>
              </Box>
            </Tooltip>
          )}
        <Tooltip
          title="Imprimer"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -12],
                  },
                },
              ],
            },
          }}
        >
          <Box
            sx={{
              height: actionsPosition?.height,
              alignContent: "center",
              backgroundColor: "#e8e8e8",
            }}
          >
            <IconButton
              aria-haspopup="true"
              onClick={() => {
                handlePrintClick(row);
              }}
              sx={{ color: "primary.main" }}
            >
              <LocalPrintshopIcon />
            </IconButton>
          </Box>
        </Tooltip>
        <Tooltip
          title="Historique"
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -12],
                  },
                },
              ],
            },
          }}
        >
          <IconButton
            aria-haspopup="true"
            onClick={() => {
              handleHistoriqueClick(row);
            }}
            sx={{ color: "primary.main" }}
          >
            <HistoryIcon />
          </IconButton>
        </Tooltip>
      </div>
    ) : null;
  };

  const handleRowEnter = (event) => {
    const rowElement = event.currentTarget;
    const rowTop = rowElement.getBoundingClientRect().top;
    const rowHeight = rowElement.getBoundingClientRect().height;
    const rowWidth = gridRef.current.getBoundingClientRect().width;
    setActionComponentHeight(rowHeight);
    setActionsPosition({
      y: rowTop,
      height: rowHeight,
      width: rowWidth,
      visible: true,
    });

    const row = findRowById(event?.currentTarget?.dataset?.id);
    setTimeout(() => {
      setHoveredRow(row);
    }, 0);
  };

  const handleRowLeave = (e) => {
    if (!isOverActionsComponent) {
      setHoveredRowId(null);
      setActionsPosition((prevState) => ({ ...prevState, visible: false }));
    }
  };

  const handleRowClick = (row, decision = false, isReglement, isReponse) => {
    let prolong = row?.codeEtat === "ECHU_SOUM_PROL";
    let dec;
    if (isDecisionMode) {
      dec = true;
    } else {
      dec = decision;
    }
    dispatch(clearTiDetails());
    if (dec) {
      dispatch(setIsDecisionTiVisible(true));
    } else {
      dispatch(setIsDecisionTiVisible(false));
    }
    navigate(TITRE_DETAIL_PAGE + row?.id, {
      state: {
        isDecision: decision ? true : false,
        dec: dec ? true : false,
        isPronlogation: prolong ? true : false,
        isReglement: isReglement,
        isReponse: isReponse,
        isMode: dec ? "GESTION" : "CONSULTER",
      },
    });
  };

  const handleHistoriqueClick = (params) => {
    navigate(TITRE_HISTORIQUE_PAGE + params?.id);
  };

  const handlePrintClick = (params) => {
    dispatch(downloadTi(params?.id));
  };

  const handleColumnVisibilityChange = (newModel) => {
    let payload = null;

    if (Object.keys(newModel).length === 0) {
      let model = {
        dateCreation: true,
        categorie: true,
        devise: true,
        montant: true,
        importateur: true,
        declarant: true,
        etat: true,
        banqueDescription: true,
      };

      setColumnVisibility(model);
      payload = {
        columnsState: model,
        density: density,
      };
    } else {
      setColumnVisibility(newModel);
      payload = {
        columnsState: newModel,
        density: density,
      };
    }

    dispatch(setTiColumnsDensityState(payload));
  };

  const handleDensityChange = (newDensity) => {
    setDensity(newDensity);
    let payload = {
      columnsState: columnVisibility,
      density: newDensity,
    };
    dispatch(setTiColumnsDensityState(payload));
  };

  const columns = [
    {
      field: "num",
      headerName: "N° d'enregistrement",
      flex: 1,
      hideable: false,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dateCreation",
      headerName: "Date de création",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "dateDomiciliation",
      headerName: "Date domiciliation",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "categorie",
      headerName: "Catégorie",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "montant",
      headerName: "Montant",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "devise",
      headerName: "Devise",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "importateur",
      headerName: "Importateur",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "declarant",
      headerName: "Declarant",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "banqueDescription",
      headerName: "Banque",
      flex: 1,
      hideable: true,
      headerClassName: "super-app-theme--header",
    },
    {
      field: "etat",
      headerName: "État",
      hideable: true,
      flex: 1.2,
      renderCell: ({ row }) => (
        <Tooltip
          title={
            <>
              {row?.etat}
              {row?.statusDT && (
                <>
                  <br />
                  {row?.statusDT}
                </>
              )}
            </>
          }
          slotProps={{
            popper: {
              modifiers: [
                {
                  name: "offset",
                  options: {
                    offset: [0, -12],
                  },
                },
              ],
            },
          }}
        >
          <Chip
            sx={row?.statusDT ? { py: 3, mr: 2 } : { mr: 2 }}
            color={getChipColorByEtatCodeTi(row?.codeEtat)}
            label={
              <>
                {row?.etat}
                <br />
                {row?.statusDT}
              </>
            }
          />
        </Tooltip>
      ),
      headerClassName: "super-app-theme--header",
    },
  ];

  const rows = [];
  props?.titres?.content?.map((row, index) => {
    rows.push({
      id: row?.id,
      num: row.numEnregistrement,
      categorie: row.typeTitreImportation?.code,
      devise: row.typeDevise?.description,
      montant: row.montantTotal,
      importateur: row.operateurImportateurExportateur?.description,
      declarant: row.transitaire?.description,
      banqueDescription: row?.banqueDescription,
      dateCreation: formattedDateTimeFromDB(row.dateCreation),
      dateDomiciliation: formattedDateTimeFromDB(row.dateDomiciliation),
      etat: row.etatDescription,
      codeEtat: row.typeEtatTitreImportation?.code,
      statusDT: row.statusDT,
    });
  });

  return (
    <PaperCustomized title="Liste des titres" forActions={false}>
      <TableCustomized
        columns={columns}
        rows={rows}
        totalElements={props?.titres?.totalElements}
        pageSizeOptions={[10, 25, 50, 100]}
        onClickRow={(params, event) => {
          if (!event.ignore) {
            handleRowClick(params);
          }
        }}
        paginationModel={props.paginationModel}
        setPaginationModel={props.setPaginationModel}
        pagination={props.paginationModel}
        initialState={{
          columns: {
            columnVisibilityModel: tiReducer?.columnsState,
          },
          pagination: {
            paginationModel: { page: 0, pageSize: 10 },
          },
        }}
        loading={props.loading}
        onRowEnter={handleRowEnter}
        onRowLeave={handleRowLeave}
        highlightRowId={hoveredRowId}
        gridRef={gridRef}
        onColumnVisibilityChange={handleColumnVisibilityChange}
        density={density}
        onDensityChange={handleDensityChange}
      />
      <ActionsComponent
        row={hoveredRow}
        yPosition={actionsPosition.y}
        isVisible={actionsPosition.visible}
        height={actionsPosition.height}
        width={actionsPosition.width}
      />
    </PaperCustomized>
  );
}

export default ListTitres;
